import { render, staticRenderFns } from "./packageList.vue?vue&type=template&id=39993041&scoped=true&"
import script from "./packageList.vue?vue&type=script&lang=js&"
export * from "./packageList.vue?vue&type=script&lang=js&"
import style0 from "./packageList.vue?vue&type=style&index=0&id=39993041&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39993041",
  null
  
)

export default component.exports